import React, { useEffect, useState } from 'react'
import { Box, Button, Paper, Stack, Table, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import moment from 'moment'
import { Item } from '../../../common/snippets'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { makeTable } from '../analysisReport/pdfAutotable'
import { RenderTable } from '../analysisReport/summmaryTable'

const BranchBalanceReportTable = ({ HeaderData, loginData , tableData}) => {
    const [state, setState] = useState({ generatePDF: false, load: false })
    const [showTable, setShowTable] = useState(true)
    const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
    const branchBalanceColumn = [
        { headerName: 'SN', exportHead: 'SN', field: 'SN', xlCol: { dataType: 'string', dataFormatter: null }, minWidth: "80px", align: "left" },
        { headerName: 'Branch State', exportHead: 'Branch State', field: 'StateName', xlCol: { dataType: 'string', dataFormatter: null }, minWidth: "100px", align: "left" },
        { headerName: 'Branch City', exportHead: 'Branch City', field: 'CityName', xlCol: { dataType: 'string', dataFormatter: null }, minWidth: "80px", align: "left" },
        { headerName: 'Branch Name', exportHead: 'Branch Name', field: 'BranchName', xlCol: { dataType: 'string', dataFormatter: null }, minWidth: "80px", align: "left" },
        { headerName: 'Opening Balance', exportHead: 'Opening Balance', field: 'OpeningBalance', xlCol: { dataType: 'number', dataFormatter: null }, minWidth: "80px", align: "right" },
        { headerName: 'Closing Balance', exportHead: 'Closing Balance', field: 'ClosingBalance', xlCol: { dataType: 'number', dataFormatter: null }, minWidth: "80px", align: "right" },
    ]
    const headerFilters = [
        { headerName: 'From Date', exportHead: 'From Date', col: 1, field: 'fromDate', xlCol: { dataType: 'string', dataFormatter: null }, minWidth: "80px", align: "left" },
        { headerName: 'To Date', exportHead: 'To Date', col: 1, field: 'toDate', xlCol: { dataType: 'string', dataFormatter: null }, minWidth: "100px", align: "left" },
        { headerName: 'Branch State', exportHead: 'Branch State', col: 1, field: 'branchState', xlCol: { dataType: 'string', dataFormatter: null }, minWidth: "80px", align: "left" },
        { headerName: 'Branch City', exportHead: 'Branch City', col: 1, field: 'branchCity', xlCol: { dataType: 'string', dataFormatter: null }, minWidth: "80px", align: "left" },
        { headerName: 'Branch Name', exportHead: 'Branch Name', col: 2, field: 'branchName', xlCol: { dataType: 'string', dataFormatter: null }, minWidth: "80px", align: "left" },
    ]
    const reportName='Branch Balance Report'
    const generatepdf = (isSave) => {
        setState({ generatePDF: true, load: true })
        jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
        jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
        const doc = new jsPDF({ orientation: 'p', format: [1080, 1528], unit: 'px', compress: true })
        const makeColumns = (cols) => cols.map(col => ({ header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }))
        autoTable(doc, {
            margin: { top: 180, left: 30, right: 30, bottom: 40 },
            columns: makeColumns(headerFilters),
            body: HeaderData,
            theme: 'grid',
            headStyles: { fontSize: 14, fillColor: [182, 222, 254], textColor: [0, 0, 0], fontStyle: '600', halign: 'left', minCellHeight: 30 },
            bodyStyles: { fontSize: 14, textColor: [0, 0, 0], minCellHeight: 26 },
            didDrawPage: (data) => {
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(18)
                doc.setFont('Roboto', 'bold')
                doc.text(`From Date : ${moment(HeaderData?.[0]?.fromDate).format('DD-MMM-YYYY')} To Date ${moment(HeaderData?.[0]?.toDate).format('DD-MMM-YYYY')}`, 30, 145)
                doc.setFontSize(18)
                doc.setFont('Roboto', 'bold')
                doc.text(`Report View: ${reportName}`, doc.internal.pageSize.width - data.settings.margin.left, 145, 'right')
            }
        })
        makeTable(doc, autoTable, makeColumns(branchBalanceColumn), tableData, 1,reportName, loginData)
        const totalPages = doc.internal.getNumberOfPages()
        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i)
            const pageSize = doc.internal.pageSize
            const pageHeight = pageSize.height || pageSize.getHeight()
            const pageWidth = pageSize.width || pageSize.getWidth()
            const str = `Page : ${i} of ${totalPages}`
            doc.setFontSize(16)
            doc.setFont('Roboto', 'bold')
            doc.text(str, pageWidth - 20, pageHeight - 5, { align: 'right' })
        }
        if (isSave) {
            doc.save(`${reportName} ${currentDateTime}.pdf`)
        }
        setTimeout(() => {
            setState({ ...state, generatePDF: false, load: true })
            const pdfUrl = doc.output('bloburl')
            document.getElementById('branchBalance').data = pdfUrl
            // document.getElementById('branchBalance').data = doc.output('datauristring', reportName)
        }, 1500)
    }
    const printClick = (isSave) => {
        setShowTable(false)
        generatepdf(isSave)
    }
    return (
        <>
            <Item className="userReport">
                <Item style={{ padding: '8px 0 0 15px' }} className="userReport-heading">Report For: {reportName}</Item>
                <Item className="userReport-buttons">
                    {showTable ? (
                        <>
                            <Box>
                                <Button
                                    variant="outlined"
                                    className="userWisereporttembtn"
                                    onClick={() => {
                                        setShowTable(false)
                                        printClick(false)
                                    }}
                                    id="PrintBtn"
                                >
                                    Print
                                </Button>
                            </Box>
                            <Box >
                                <ReactHtmlTableToExcel
                                    id="ExpToExlbtn"
                                    className="userWisereporttemExcelBtn"
                                    table="table-to-xls"
                                    filename={`${reportName} ${currentDateTime}`}
                                    sheet="tablexls"
                                    buttonText="Export to Excel"
                                />
                            </Box>
                        </>
                    ) : (
                        <>
                            <Box>
                                <Button
                                    id="backBtn"
                                    variant="outlined"
                                    className="userWisereporttembtn"
                                    onClick={() => { setShowTable(true) }}
                                >
                                    Back
                                </Button>
                            </Box>
                        </>
                    )}
                </Item>
            </Item>
            {showTable ? (
                <Stack sx={{ margin: 2, height: 430, paddingTop: '10px' }}>
                    <TableContainer component={Paper} style={{ border: '1px solid #aeaeae' }}>
                        <Table id="table-to-xls" size="small">
                            <TableHead style={{ display: 'none' }}>
                                <TableRow>
                                    <TableCell className="reportTD" style={{ fontSize: '25px', fontWeight: '500', textAlign: 'left' }} colSpan={3}>Report For: {reportName}</TableCell>
                                    <TableCell className="reportTD" style={{ fontSize: '25px', fontWeight: '500', textAlign: 'left' }} colSpan={3}>Company Name: {loginData.strCompanyName}</TableCell>
                                </TableRow>
                                <TableRow>
                                    {headerFilters.map((h, i) => (
                                        <TableCell style={{ backgroundColor: '#e5f3ff', color: '#454646', fontSize: '22px', fontWeight: '500', textAlign: 'left' }} key={i} colSpan={h.col}>{h.headerName}</TableCell>
                                    ))}
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}>{moment(HeaderData?.[0]?.fromDate).format('DD-MMM-YYYY')}</TableCell>
                                    <TableCell style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}>{moment(HeaderData?.[0]?.toDate).format('DD-MMM-YYYY')}</TableCell>
                                    <TableCell style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}>{HeaderData?.[0]?.branchState}</TableCell>
                                    <TableCell style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}>{HeaderData?.[0]?.branchCity}</TableCell>
                                    <TableCell style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }} colSpan={2}>{HeaderData?.[0]?.branchName}</TableCell>
                                </TableRow>
                            </TableHead>
                            <RenderTable header={branchBalanceColumn} data={tableData} key1={'ands'} key2={'ssade45'} key3={'wrdcdc'} />
                        </Table>
                    </TableContainer>
                </Stack>
            ) : (
                <>
                    {state.generatePDF && <div className="generatePDF">Generating PDF....</div>}
                    {state.load && (
                        <Box sx={{ ...sx.reportFlex, justifyContent: 'center' }}>
                            <object id="branchBalance" type="application/pdf" width="100%" height="440"></object>
                        </Box>
                    )}
                </>
            )}
        </>
    )
}
export default BranchBalanceReportTable
